export default __webpack_public_path__ + "static/media/white-plus.7fb8be67.svg";